import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";

export class ShowroomValidation {
    static init(): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.skapa).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 4,
                message: { text: "Det här fältet är obligatoriskt" },
                model: () => null,
                name: "required",
                required: true,
                triggerOnLoad: true
            }
        ]);
        return context;
    }
}
